module.exports = __webpack_public_path__ + "img/V-63-ER-1200-MI.52716827.png";